




































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { MessageService } from "@/shared/services/message-service";
import centrosModule from "@/store/modules/centros-module";
import centros_serviciosModule from "@/store/modules/centros_servicios-module";
import { centros } from "@/shared/dtos/centros";
import { centros_servicios } from "@/shared/dtos/centros_servicios";

interface CentroOption {
  value: number;
  text: string;
}

@Component({
  name: "CentrosServiciosManager",
})
export default class CentrosServiciosManager extends Vue {
  public loading: boolean = false;
  public saving: boolean = false;
  public dialogOpen: boolean = false;
  public isEditMode: boolean = false;

  public centroFilter: number | null = null;
  public searchText: string = "";
  public servicioForm: centros_servicios = new centros_servicios();

  public headers: any[] = [
    { text: "Centro", value: "centro_id", width: "220px" },
    { text: "Código", value: "codigo_elegido", width: "140px" },
    { text: "Servicio", value: "servicio" },
    { text: "Tiempo", value: "tiempo_minutos", width: "120px" },
    { text: "Estado", value: "is_enabled", width: "130px" },
    {
      text: "Acciones",
      value: "actions",
      sortable: false,
      align: "center",
      width: "110px",
    },
  ];

  public mounted() {
    this.refresh();
  }

  public get centrosList(): centros[] {
    return centrosModule.centros;
  }

  public get serviciosList(): centros_servicios[] {
    return centros_serviciosModule.centros_servicios;
  }

  public get centroOptions(): CentroOption[] {
    return this.centrosList
      .map((c) => {
        const text = c.nombre
          ? c.nombre + " (" + c.agent_id + ")"
          : "Centro " + c.id;
        return {
          value: c.id,
          text,
        };
      })
      .sort((a, b) => a.text.localeCompare(b.text));
  }

  public get filteredItems(): centros_servicios[] {
    const search = (this.searchText || "").toLowerCase().trim();
    const centroId = this.centroFilter;

    return this.serviciosList.filter((x) => {
      const passCentro = centroId === null || x.centro_id === centroId;
      if (!passCentro) return false;

      if (search === "") return true;

      const blob = [
        x.categoria,
        x.codigo_elegido,
        x.servicio,
        this.getCentroName(x.centro_id),
      ]
        .concat([x.descripcion])
        .join(" ")
        .toLowerCase();

      return blob.indexOf(search) !== -1;
    });
  }

  public getCentroName(centroId: number): string {
    const centro = this.centrosList.find((c) => c.id === centroId);
    if (!centro) {
      return "Centro " + centroId;
    }
    return centro.nombre;
  }

  public async refresh() {
    this.loading = true;
    try {
      await Promise.all([
        centersafe(centrosModule.getcentros()),
        centersafe(centros_serviciosModule.getcentros_servicios()),
      ]);
    } finally {
      this.loading = false;
    }
  }

  public openCreate() {
    this.isEditMode = false;
    this.servicioForm = new centros_servicios();
    this.servicioForm.is_enabled = true;
    this.servicioForm.is_deleted = false;
    if (this.centroFilter !== null) {
      this.servicioForm.centro_id = this.centroFilter;
    }
    this.dialogOpen = true;
  }

  public openEdit(item: centros_servicios) {
    this.isEditMode = true;
    this.servicioForm = new centros_servicios(item);
    this.dialogOpen = true;
  }

  public async save() {
    if (
      !this.servicioForm.centro_id ||
      !this.servicioForm.categoria ||
      !this.servicioForm.codigo_elegido ||
      !this.servicioForm.servicio ||
      !this.servicioForm.tiempo_minutos ||
      this.servicioForm.tiempo_minutos <= 0
    ) {
      MessageService.alert(
        "Validación",
        "Centro, categoría, código, servicio y tiempo son obligatorios",
        MessageService.TypeWarning
      );
      return;
    }

    this.saving = true;
    try {
      if (this.isEditMode) {
        await centros_serviciosModule.modificarcentro_servicio(
          this.servicioForm
        );
      } else {
        await centros_serviciosModule.guardarcentro_servicio(this.servicioForm);
      }
      MessageService.toast("Servicio de centro guardado correctamente");
      this.dialogOpen = false;
      await this.refresh();
    } catch (error) {
      MessageService.alert(
        "Error",
        "No se pudo guardar el servicio de centro",
        MessageService.TypeError
      );
    } finally {
      this.saving = false;
    }
  }

  public remove(item: centros_servicios) {
    MessageService.confirm(
      "¿Quieres eliminar este servicio del centro?",
      "Confirmación",
      async (res: boolean) => {
        if (!res) return;
        try {
          await centros_serviciosModule.eliminarcentro_servicio(item);
          MessageService.toast("Servicio eliminado correctamente");
          await this.refresh();
        } catch (error) {
          MessageService.alert(
            "Error",
            "No se pudo eliminar el servicio",
            MessageService.TypeError
          );
        }
      }
    );
  }
}

async function centersafe(promise: Promise<any>) {
  try {
    await promise;
  } catch (e) {
    // Controlado en la UI con mensajes específicos.
  }
}
